// extracted by mini-css-extract-plugin
export default {"waves":"Wave_waves__HBt9O","parallax":"Wave_parallax__tq5LL","move-forever":"Wave_move-forever__4yU+s","content":"Wave_content__eakp9"};